import { OrderProjectOptionsVm } from '@/types';

type AccessAddonInfo = {
  label: string;
  description: string;
};

export const accessAddonInfo: Record<keyof OrderProjectOptionsVm, AccessAddonInfo> = {
  rainGutters: {
    label: 'Gutters and Downspouts',
    description:
      'Furnish and install new rain gutters and downspouts; remove and replace existing. Do not include information not related to this scope.',
  },
  decking: {
    label: 'Decking',
    description:
      'Furnish and install new decking; Remove and replace existing. Do not include information not related to this scope.',
  },
  skylights: {
    label: 'Skylight',
    description: 'Do not include information not related to this scope.',
  },
  gutters: {
    label: 'Gutter Screens',
    description:
      'Furnish and install gutter covers. Do not include information not related to this scope.',
  },
};
